var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "wrap", staticClass: "wrap" },
    [
      !_vm.imageUrl
        ? _c("div", { staticClass: "empty" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("maintenance.overview2d.selectAMediaToStart")) +
                "\n  "
            )
          ])
        : _c(
            "v-stage",
            {
              ref: "stage",
              attrs: { config: _vm.stageConfig },
              on: {
                mousedown: _vm.onStageMouseDown,
                touchstart: _vm.onStageMouseDown,
                mousemove: _vm.onStageMouseMove,
                mouseup: _vm.onStageMouseUp,
                mouseleave: _vm.onStageMouseUp,
                contextmenu: _vm.onStageContextMenu
              }
            },
            [
              _c(
                "v-layer",
                { ref: "layer" },
                [
                  _c("v-image", { attrs: { config: _vm.imageConfig } }),
                  _vm._v(" "),
                  _vm._l(_vm.visibleMarkers, function(m) {
                    return _c("v-circle", {
                      key: m.id,
                      attrs: { config: _vm.markerConfig(m) },
                      on: {
                        dragstart: function($event) {
                          return _vm.selectMarker(m.id)
                        },
                        click: function($event) {
                          return _vm.selectMarker(m.id)
                        },
                        tap: function($event) {
                          return _vm.selectMarker(m.id)
                        },
                        mouseenter: function($event) {
                          return _vm.onMarkerEnter(m.id)
                        },
                        mouseleave: function($event) {
                          return _vm.onMarkerLeave(m.id)
                        },
                        dragend: function($event) {
                          return _vm.onMarkerDragEnd(m.id, $event)
                        },
                        dblclick: function($event) {
                          return _vm.removeMarker(m.id)
                        },
                        dbltap: function($event) {
                          return _vm.removeMarker(m.id)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.visibleMarkers, function(m) {
                    return _c("v-text", {
                      key: m.id + ":label",
                      attrs: { config: _vm.labelConfig(m) },
                      on: {
                        click: function($event) {
                          return _vm.selectMarker(m.id)
                        },
                        tap: function($event) {
                          return _vm.selectMarker(m.id)
                        },
                        mouseenter: function($event) {
                          return _vm.onMarkerEnter(m.id)
                        },
                        mouseleave: function($event) {
                          return _vm.onMarkerLeave(m.id)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm.tooltip.visible
                    ? _c(
                        "v-label",
                        { attrs: { config: _vm.tooltipLabelConfig } },
                        [
                          _c("v-tag", {
                            attrs: { config: _vm.tooltipTagConfig }
                          }),
                          _vm._v(" "),
                          _c("v-text", {
                            attrs: { config: _vm.tooltipTextConfig }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
      _vm._v(" "),
      _c("MarkerAddModal", {
        ref: "addModal",
        on: { save: _vm.confirmPendingAdd }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }